module.exports = __webpack_public_path__ + "static/finance2.5194e9ee.png";